module.exports = __webpack_public_path__ + "img/tri-logo-large.284b11cc.png";